import { Box, IconButton, MenuItem, SelectChangeEvent, TextField } from "@mui/material";
import Typography from "../typography/typography";
import Select from "../select/select";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightICon from "@mui/icons-material/ChevronRight";
import "./pagination.scss";
import { IPaginationModel } from "../../@types/pagination-model";
import { useLanguage } from '@erpsquad/common/runtime';
import { usePages } from '@erpsquad/common/runtime';
import { useEffect } from "react";

interface IPagination {
  paginationModel: IPaginationModel;
  handlePaginationModel: (model: IPaginationModel) => void;
  totalPages: number;
}

const Pagination = ({
  paginationModel,
  totalPages,
  handlePaginationModel,
}: IPagination) => {
  const { pageNo, limit } = paginationModel;
  const skip=limit*(pageNo-1)
  const pageSizeOptions = [10, 20, 50];
  const {isRtl}=useLanguage();
 const {setIsChanged,setActivePage,activePage}=usePages();
  const handleLimitChange = (e: SelectChangeEvent<unknown>) => {
    const newModel = {
      ...paginationModel,
      page: 1,
      pageNo: 1,
      limit: e?.target?.value as number,
    };
    handlePaginationModel(newModel);
  };

  const handleNextPage = () => {
    if (pageNo < totalPages) {
      const newModel = {
        ...paginationModel,
        pageNo: parseInt(pageNo) + 1,
      };
      handlePaginationModel(newModel);
      setIsChanged(true)
    }
  };
  const handlePrevPage = () => {
    if (pageNo > 1) {
      const newModel = {
        ...paginationModel,
        pageNo: parseInt(pageNo) - 1,
      };
      handlePaginationModel(newModel);
      setIsChanged(true)
    }
  };

  const handleEnterKey = (event) => {
    if (event.key === 'Enter') {
      const value = event.target.value;
      if (parseInt(value) > 0 && parseInt(value) <= totalPages) {
        const newModel = {
          ...paginationModel,
          pageNo: parseInt(value),
        };  
        handlePaginationModel(newModel);
        setIsChanged(true)
      }
      
    }
  };

  useEffect(()=>{
    setActivePage({...activePage,skip,pageNo})
    //eslint-disable-next-line react-hooks/exhaustive-deps
  },[pageNo])



  return (
    <Box className="pagination" borderTop={"2px solid theme.secondary.200"}>
      <Typography color="theme.secondary.800" type="s4">
        Items per page :
      </Typography>
      <Select
        value={limit}
        size="small"
        className="page-size-select page-size-select-pagination"
        onChange={handleLimitChange}
        variant="outlined"
        MenuProps={{
          sx:{
            maxWidth:"unset"
          }
        }}
      >
        {pageSizeOptions?.map((size) => (
          <MenuItem key={size} value={size}>
            {size}
          </MenuItem>
        ))}
      </Select>

      <Typography color="theme.secondary.800" type="s4">
        Go To :
      </Typography>

        <TextField
          type="number"
          className="goto-box"
          id="outlined-required"
          defaultValue=""
          onKeyDown={handleEnterKey}
        />

      <IconButton onClick={handlePrevPage} size="small" disabled={paginationModel.pageNo === 1}>
       {isRtl ? <ChevronRightICon /> : <ChevronLeftIcon />} 
      </IconButton>
      <Typography
       sx={{
         ...(isRtl ? { ml: 0.5 } : { mr: 0.5 })
       }}
        type="s4"
        weight="normal"
        color="theme.secondary.700"
      >
        Page{" "}
      </Typography>
      {/* <input value={pageNo} type="number" className="page-input" />{" "} */}
      <Typography type="s4" weight="medium" color="theme.secondary.1000">
        {pageNo}{" "}
      </Typography>
      <Typography
        mx={0.5}
        type="s4"
        weight="normal"
        color="theme.secondary.700"
      >
        of{" "}
      </Typography>
      <Typography type="s4" weight="medium" color="theme.secondary.1000">
        {totalPages || 1}
      </Typography>
      {/* </Box> */}
      <IconButton onClick={handleNextPage} size="small" disabled={paginationModel.pageNo === totalPages}>
        {isRtl ? <ChevronLeftIcon /> :<ChevronRightICon />}
      </IconButton>
    </Box>
  );
};

export { Pagination };
export default Pagination;
